/**
 * SFN i18n — Deutsch. Full translation; spreads EN as base for safety.
 */
import type { Dict } from "./types";
import { en } from "./en";

export const de: Dict = {
  ...en,
  "nav.home": "Start",
  "nav.about": "Über uns",
  "nav.contact": "Kontakt",
  "nav.ecosystem": "Ökosystem",
  "nav.tokens": "Tokens",
  "nav.protection": "Schutz",
  "nav.secure": "Sichern",
  "nav.faq": "FAQ",
  "hero.eyebrow": "Geprüfter Inflationsschutz für 1 $ auf Solana",
  "hero.stat1": "Mahlzeiten gesichert",
  "hero.stat2": "Reale Deckung",
  "hero.stat3": "Ø Abwicklung",
  "bento.title": "Das Sustainable Food & Eco Network (SFN): So funktioniert es",
  "bento.sub": "Tokenomics, Nutzen und Resilienz — komponiert wie ein Tasting-Menü.",
  "bento.live": "Live-Supply",
  "bento.live.d": "Echtzeit zirkulierende Meal4 und Meal2, on-chain transparent.",
  "bento.kitchen": "Anker-Küche",
  "bento.kitchen.d": "Aktive Pilotküche in der Thailand-Sandbox — tägliche Mahlzeiten.",
  "bento.assets": "Immobilien-Deckung",
  "bento.assets.d": "Land und Gebäude besichern den Stabilisator-Pool.",
  "bento.audit": "Geprüfte Reserven",
  "bento.audit.d": "Quartalsweiser Proof-of-Reserves und Supply-Nachweis.",
  "bento.uptime": "Netzwerk-Uptime",
  "bento.community": "Community-Halter",
  "bento.card1.title": "Die Vision & das Netzwerk (SFN)",
  "bento.card1.text":
    "SFN ist ein offenes, dezentrales Netzwerk zertifizierter Partnerküchen, lokaler Bauern und Unterstützer. Durch die Vereinigung von Community-Finanzierung und solarbetriebenen Operationen halten wir die Kosten der Lebensmittelproduktion unschlagbar niedrig und stabil.",
  "bento.card2.title": "Dezentraler regionaler Sourcing-Hub",
  "bento.card2.text":
    "Unsere Anker-Operation dient als lebendiges, reales Testfeld, in dem das 30-THB-Mahlzeiten-Framework täglich validiert wird. Von diesem Hub aus koordinieren wir Großeinkauf, solarbetriebene Küchen-Infrastruktur und die operativen Standards, die jeder Partnerstandort übernimmt.",

  "bento.card3.title": "Skalierbare globale Wirkung",
  "bento.card3.text":
    "Wir hören nicht bei einer Küche auf. SFN ist zum Wachstum konzipiert. Internationale Unterstützer können Mahlzeiten digital sponsern, während traditionelle lokale Garküchen unserem Netzwerk beitreten können, um Zugang zu subventionierten Zutaten und Solarenergie zu erhalten.",

  "milestones.eyebrow": "SOFORTIGE ROADMAP: VERBINDUNG VON BLOCKCHAIN MIT PHysischer INFRASTRUKTUR",
  "milestones.p1.title": "Das SFN Zentralküchen-Hub (Thailand-Sandbox)",
  "milestones.p1.desc":
    "Finanziert durch institutionelles Kapital, wird unsere kommende automatisierte Zentralverarbeitungsanlage den Großeinkauf von Zutaten, solarbetriebene Kühlung und Zero-Waste-Mahlzeitenproduktion übernehmen. Das eliminiert Zwischenhändlerkosten und garantiert Preisstabilität vor der Verteilung.",
  "milestones.p1.target": "100% Solarbetriebene Lieferkettenvernetzung.",
  "milestones.p2.title": "Hyper-Expansion von Smart Express-Filialen",
  "milestones.p2.desc":
    "Skalierung unseres bewährten Gastronomie-Frameworks vom ersten Ankerstandort in ein regionales Netzwerk hocheffizienter Express-Food-Filialen an verkehrsreichen Hauptachsen. Jede Filiale operiert auf subventionierten Null-Energiekosten-Netzen.",
  "milestones.p2.target": "Regionaler Multi-Standort-Sandbox-Rollout.",

  "pilot.eyebrow": "Live-Pilot Proof of Concept: Thailand Sandbox",
  "pilot.title": "Thailand als geschlossener Pilotmarkt (Sandbox)",
  "pilot.body":
    "Der Start in einem hocheffizienten regionalen Markt erlaubt es, die MEAL4-/MEAL2-Tokenomics und reale Lieferketten unter maximaler operativer Kontrolle zu validieren. Jede Küche, jeder Zutatenfluss und jeder Settlement-Pfad wird in einer abgegrenzten Umgebung geprüft, bevor SFN den internationalen Rollout vollzieht.",
  "pilot.benchmark.label": "Globaler Benchmark: 1 $",
  "pilot.benchmark.value": "1 $",
  "pilot.benchmark.desc":
    "Wir sichern Mahlzeiten-Preisstabilität unter 1 $ — lokal verankert bei 30 THB pro Mahlzeit — über lokalisierte Web3-Mechaniken, die globale Skalierbarkeit belegen.",
  "pilot.phase1": "Phase 1: Regionaler Pilot (Ziel 1 $)",
  "pilot.phase2": "Phase 2: Globale Skalierung nach erfolgreicher Pilotphase",
  "pilot.phase.arrow": "Roadmap-Pfad",
  "pilot.stat1.label": "Pilotmarkt",
  "pilot.stat1.value": "Thailand Sandbox",
  "pilot.stat2.label": "Mahlzeiten-Anker",
  "pilot.stat2.value": "1 $",
  "pilot.stat3.label": "Nächste Phase",
  "pilot.stat3.value": "Globaler Rollout",

  "about.eyebrow": "Gründer & Mission",
  "about.titleA": "Hinter dem",
  "about.titleB": "Sustainable Food & Eco Network",
  "about.body":
    "SFN wurde von einem unternehmerischen Team gegründet, das klassische deutsche Betriebswirtschaft mit gelebter thailändischer Gastronomie verbindet. Aus der direkten Beobachtung, wie globale Inflation lokale Gemeinschaften trifft, ist die Entscheidung gewachsen, Blockchain-Technologie nicht für Spekulation, sondern für elementare menschliche Stabilität einzusetzen. Unsere Pilotküche in Thailand, Thailand, dient als operative Blaupause für eine transparente, solarbetriebene und dezentrale Zukunft der Ernährungssicherheit.",

  "contact.eyebrow": "Partnerschaftsanfrage",
  "contact.titleA": "Werden Sie Teil des",
  "contact.titleB": "Netzwerks",
  "contact.body":
    "Sind Sie eine lokale Küche, die MEAL-Token akzeptieren möchte, ein Landwirt, der uns direkt beliefern will, oder ein internationaler Unterstützer mit Fragen? Nehmen Sie Kontakt zu uns auf.",
  "contact.name": "Name",
  "contact.namePh": "Ihr Name",
  "contact.email": "E-Mail",
  "contact.emailPh": "sie@beispiel.de",
  "contact.subject": "Betreff",
  "contact.subjectPh": "Partnerschaft, Belieferung, Support…",
  "contact.message": "Nachricht",
  "contact.messagePh": "Erzählen Sie uns von Ihrem Projekt oder Ihrer Frage…",
  "contact.sent": "Nachricht sicher übermittelt",
  "contact.successBody":
    "Ihre Nachricht wurde über unseren verschlüsselten Endpunkt zugestellt. Wir melden uns innerhalb von 48 Stunden.",
  "contact.errorTitle": "Übertragung fehlgeschlagen",
  "contact.errorBody":
    "Ihre Nachricht konnte nicht zugestellt werden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "contact.dismissOk": "Weitere senden",
  "contact.dismissError": "Erneut versuchen",
  "contact.responseNote": "Wir antworten in der Regel innerhalb von 48 Stunden.",
  "contact.send": "Nachricht senden",


  "dual.eyebrow": "Dual-Token Architektur",
  "dual.title": "Unser Dual-Token-System: Sicherheit trifft auf Nutzen",
  "dual.sub":
    "Meal4 bewegt Wert. Meal2 hält ihn ruhig. Zusammen wird Ernährungssicherheit ausgabefähig.",
  "dual.meal4.role": "Inflationsschutz",
  "dual.meal4.t": "MEAL4 \u2013 Der Inflationsschutz",
  "dual.meal4.d":
    "Streng auf 1.000.000 Tokens limitiert, ohne jemals mehr zu schaffen. MEAL4 fungiert als digitaler Vertrag, gedeckt durch physische Vermögensreserven und strategische Großhandelskraft. Es friert die Kosten der Lebensmittelproduktion im Kern ein und schafft eine deflationäre Absicherung gegen steigende Marktpreise.",
  "dual.meal4.b1": "1.000.000 Tokens \u2014 niemals mehr",
  "dual.meal4.b2": "Gedeckt durch reale Vermögensreserven",
  "dual.meal4.b3": "Deflationärer Schutz gegen Inflation",
  "dual.meal2.role": "Täglicher Nutzen",
  "dual.meal2.t": "MEAL2 \u2013 Der tägliche Nutzen",
  "dual.meal2.d":
    "Der praktische Alltags-Token, entwickelt für reibungslose Restaurantabläufe, Belohnungen und Gemeinschaftshilfe. MEAL2 treibt das Ökosystem an, indem es sofortige mobile Zahlungen, Treuerabatte für lokale Gäste und transparentes digitales Mahlzeitensponsoring von globalen Unterstützern ermöglicht.",
  "dual.meal2.b1": "Sofortige mobile Zahlungen",
  "dual.meal2.b2": "Treueprogramm & Rabatte",
  "dual.meal2.b3": "Transparentes digitales Mahlzeitensponsoring",
  "dual.flow": "Energiefluss",
  "dual.flow.d": "Meal2-Reserven stabilisieren Meal4 fortlaufend — wie die Sauce zum Gericht.",
  "protection.eyebrow": "Unveränderliche Sicherheit · On-Chain",
  "protection.title": "Unwiderrufliches Vertrauen, in Code gegossen",
  "protection.sub":
    "Wir haben strenge Sicherheitsparameter direkt in unsere Smart Contracts hartcodiert, um die Community vor Inflation und unbefugten Änderungen zu schützen.",
  "protection.f1.title": "100% Einfrier-sichere Vermögenswerte",
  "protection.f1.text":
    "Die 'Freeze Authority' wurde für beide Tokens dauerhaft widerrufen. Keine zentrale Macht, Institution oder Entwickler kann jemals Ihre Wallet einfrieren oder Sie daran hindern, Ihre MEAL-Token zu nutzen.",
  "protection.f2.title": "Hartcodierter Supply-Cap (MEAL4)",
  "protection.f2.text":
    "Die 'Mint Authority' für MEAL4 wurde unwiderruflich zerstört. Es ist mathematisch unmöglich, jemals mehr als 1.000.000 MEAL4-Token zu prägen, wodurch Ihr Ernährungssicherheits-Hedge dauerhaft vor Entwertung geschützt ist.",
  "protection.f3.title": "Flexible Nutzen-Expansion (MEAL2)",
  "protection.f3.text":
    "Wir haben die Prägefunktion für MEAL2 bewusst beibehalten, um nahtlos mit neuen Partnerküchen im Sustainable Food & Eco Network zu skalieren und sicherzustellen, dass lokale Ökonomien immer genug Transaktionskraft haben.",
  "swap.eyebrow": "Token-Verkauf",
  "swap.title": "Sichere deine Mahlzeiten",
  "swap.sub":
    "Tausche direkt in Meal4. Jeder Token garantiert eine Mahlzeit in der Partner-Küche — heute, morgen, nach jeder Krise.",
  "swap.from": "Du sendest",
  "swap.to": "Geschätzte gesicherte Mahlzeiten",
  "swap.balance": "Guthaben",
  "swap.quoting": "Preisimpact wird berechnet…",
  "swap.meal4.cta": "Jetzt beitragen",
  "swap.meal4.confirm": "Beitrag bestätigen",
  "swap.meal2.cta": "MEAL2-Guthaben holen",
  "swap.meal2.confirm": "Kauf bestätigen",
  "swap.confirming": "Wird bestätigt…",
  "swap.tx.awaitingApproval": "Warte auf Wallet-Freigabe…",
  "swap.tx.confirmingChain": "Wird im Solana-Netzwerk bestätigt…",
  "swap.tx.success": "Erfolg — Zahlung on-chain bestätigt",
  "swap.tx.rejected": "Transaktion in der Wallet abgelehnt.",
  "swap.tx.insufficient": "Guthaben reicht für diese Überweisung nicht aus.",
  "swap.tx.clusterMismatch": "Deine Wallet ist in einem anderen Netzwerk. Wechsle zu Solana Mainnet und versuche es erneut.",
  "swap.tx.walletMissing": "Keine Solana-Wallet erkannt. Verbinde Phantom oder Solflare und versuche es erneut.",
  "swap.phantomApproving": "Warte auf Phantom-Freigabe…",
  "swap.meal2.rateLabel": "Fester Kurs · 1 USDC = 1 MEAL2",
  "swap.meal2.payWith": "Bezahlen mit",
  "swap.meal2.solRoute": "Auto-Routing: SOL → USD (Jupiter) → MEAL2 zu 1 $ pro Einheit",
  "swap.meal2.priceFallback": "Referenzpreis (Feed offline)",
  "swap.rate": "1 USDC ≈ 1 Meal4 · Keine versteckten Gebühren",
  "swap.btn": "Verbinden & Tauschen",
  "swap.soon": "Swap powered by Thirdweb · in Kürze",
  "swap.meal4.milestoneLabel":
    "Aktueller Meilenstein: Phase-1-Ziel — Thailand-Sandbox-Zentralküchen-Infrastruktur & erste Express-Expansion",
  "swap.meal4.milestoneProgress": "{raised} / {goal} USDC eingeworben",
  "swap.meal4.percent": "{pct}% finanziert",
  "swap.meal4.treasuryLabel": "Projekt-Treasury-Wallet",
  "swap.meal4.treasuryNote":
    "Beiträge fließen direkt an die SFN-Projekt-Treasury — keine DEX, kein Open-Market-Routing.",
  "swap.meal4.tooltip":
    "Die Token-Verteilung ist direkt durch physische Bestände gedeckt und wird in Meilenstein-Finanzierungsphasen verwaltet, um Preisstabilität zu gewährleisten.",
  "swap.meal4.tooltipAria": "Wie Meilenstein-Finanzierung funktioniert",
  "trust.eyebrow": "Transparenz & Vertrauen",
  "trust.title": "Gedeckt durch Dinge, die du anfassen kannst.",
  "trust.body":
    "Das Ökosystem ist an physische Vermögenswerte gebunden: unsere SFN-Pilotküche in Thailand, Immobilien und eine aktive Küche, die täglich echte Teller serviert. Wir teilen Regionen und Betrieb offen — genaue Adressen schützen wir.",
  "trust.b1": "Aktives Restaurant",
  "trust.b2": "Immobilien-Deckung",
  "trust.b3": "Geprüfte Versorgung",
  "faq.eyebrow": "FAQ",
  "faq.title": "Häufig gestellte Fragen",
  "faq.sub":
    "Alles, was Sie über das Sustainable Food & Eco Network (SFN) und unser Ökosystem zur Mahlzeitenstabilisierung wissen müssen.",
  "faq.q1":
    "Wie können Sie trotz Inflation eine gesunde, hochwertige Mahlzeit für 1 $ garantieren?",
  "faq.a1":
    "Wir erreichen dies durch die Kombination von drei Kernpfeilern: strategischem Bulk-Einkauf von Rohzutaten direkt von lokalen Bauern, Senkung der Betriebskosten durch Solar-Infrastruktur und Community-Unterstützung durch den MEAL4-Inflationsschutz. Dadurch wird unsere Küchen-Grundpreisgestaltung vollständig von volatiler Marktinflation entkoppelt.",
  "faq.q2": "Kann ein einzelnes Restaurant die Nachfrage bewältigen, wenn der Token skaliert?",
  "faq.a2":
    "Nein, und es muss das auch nicht. Unsere SFN-Pilotküche dient als aktiver realer Proof-of-Concept. Die übergreifende Architektur ist das SFN (Sustainable Food & Eco Network). Mit wachsender Nachfrage können unabhängige lokale Küchen und Garküchen dem Netzwerk beitreten, um Zugang zu subventionierten Zutaten und Infrastruktur zu erhalten und das 30-THB-Mahlzeiten-Versprechen global zu skalieren.",
  "faq.q3":
    "Wie können internationale Unterstützer teilnehmen, wenn sie nicht in Thailand leben?",
  "faq.a3":
    "Globale Unterstützer können MEAL2-Token erwerben, um digitale 'Mahlzeitensponsoring' zu initiieren. Diese gesponserten Token werden transparent an lokale Sozialhilfeprogramme zugewiesen, damit Senioren, einkommensschwache Familien oder vulnerable Gruppen in jeder zertifizierten SFN-Küche kostenlos oder für 30 THB essen können.",
  "faq.q4": "Was unterscheidet MEAL4 von einer Standard-Kryptowährung?",
  "faq.a4":
    "Im Gegensatz zu spekulativen Tokens ist MEAL4 ein praktischer Vertrag, gedeckt durch den Ausbau realer physischer Lebensmittelreserven und nachhaltiger Gastronomie-Infrastruktur. Mit seiner dauerhaft zerstörten Prägeautorität fungiert er als mathematisch gedeckter Wertspeicher, der für Ernährungssicherheit konzipiert ist.",
  "footer.tag":
    "SFN (Sustainable Food & Eco Network) & MealToken24 setzen Blockchain-Technologie gezielt gegen Inflation und globale Ernährungsunsicherheit ein. Angetrieben von echten Küchen, gebaut für echte Menschen.",
  "footer.disclaimer":
    "Haftungsausschluss: MEAL2 und MEAL4 sind Utility- und asset-gedeckte Community-Tokens, die für den praktischen Einsatz im Gastronomie-Ökosystem des Sustainable Food & Eco Network konzipiert sind. Sie stellen keine Finanzanlagen oder traditionellen Wertpapiere dar.",
  "footer.about": "Über uns",
  "footer.contact": "Kontakt",
  "footer.legal": "Rechtliches",
  "footer.rights": "Alle Rechte vorbehalten.",
  "roadmap.eyebrow": "Umsetzung · Trajektorie",
  "roadmap.title": "Vom Werkshof zum globalen Protokoll",
  "roadmap.sub":
    "Eine sechsstufige Geschichte realer Iteration. Jeder Meilenstein ist in operativer Realität verankert, nicht in einer Präsentation.",
  "roadmap.card1.q": "2022",
  "roadmap.card1.title": "Lebensmittelversorgung für Werksarbeiter",
  "roadmap.card1.desc":
    "Beobachtung der täglichen Lebensmittelinflation jenseits 45 THB pro Mahlzeit, wodurch Werksarbeiter und einkommensschwache Gemeinschaften zunehmend von gesunder Ernährung ausgeschlossen wurden.",
  "roadmap.card2.q": "2023",
  "roadmap.card2.title": "Das 1 $-Framework-Konzept",
  "roadmap.card2.desc":
    "Entwicklung des ökonomischen Kernframeworks mit Fokus auf eine stabile 30-THB-Marge — das Fundament für eine dauerhaft erschwingliche, hochwertige Mahlzeit.",
  "roadmap.card3.q": "2024",
  "roadmap.card3.title": "Lieferketten-Sourcing-Tests",
  "roadmap.card3.desc":
    "Direkt-vom-Bauern-Sourcing-Pilotprojekte und Erkenntnisse zu den strukturellen Grenzen eines Single-Branch-Modells, die das Konzept eines dezentralen regionalen Sourcing-Hubs begründeten.",
  "roadmap.card4.q": "2025",
  "roadmap.card4.title": "Multi-Branch-Skalierung & Solar-Wurzeln",
  "roadmap.card4.desc":
    "Expansion in mehrere Filialen und Aufdeckung konsistenter Energie-Overhead-Muster, die Solar-Infrastruktur als fehlende Kostenstabilisierungs-Ebene validierten.",
  "roadmap.card5.q": "2026 | Q1",
  "roadmap.card5.title": "Operativer Nachweis & 1 $-Pilot",
  "roadmap.card5.desc":
    "Absolute Verkaufsstabilität über den gesamten Monat erreicht — keine Einbrüche zur Monatsmitte — der Beweis, dass das 30-THB-Mahlzeitenmodell operativ skalierbar ist.",
  "roadmap.card6.q": "2026 | Mid-May+",
  "roadmap.card6.title": "SFN-Tokenisierung & SolarPando-Sprint",
  "roadmap.card6.desc":
    "Offizieller Launch von SFN auf Solana: MEAL4- und MEAL2-Token-Genesis, Unveränderlichkeits-Verifizierung und Start des SolarPando-Infrastruktur-Sprints.",

  "docs.eyebrow": "Wissensdatenbank",
  "docs.title": "Whitepaper & Rechtsdokumente",
  "docs.sub": "Laden Sie die offizielle SFN-Dokumentation und Prüfberichte herunter.",
  "credits.line": "Konzept & Framework erstellt von Boy Khomkrit — Erstveröffentlichung: 04. Juli 2021",
  "credits.date": "Ursprüngliches Erstellungsdatum: 04. Juli 2021 (04.07.2021)",
  "credits.version": "Whitepaper v1.0 — Erstveröffentlichung: 04. Juli 2021",
  "docs.btn1": "SFN Ecosystem Whitepaper (EN)",
  "docs.btn2": "Executive Tokenomics Summary (DE)",
  "docs.btn3": "Thailand Gastronomy Legal Framework",
  "docs.btn4": "Cryptographic Security Audit Report",
  "vp.eyebrow": "VillagePando · Ökosystem-Gateway",
  "vp.title": "Ein Netzwerk, mehrere Schichten.",
  "vp.sub":
    "MEAL24 ist der aktive Anker. SolarPando, PlantyPando und AquaPando docken am selben On-Chain-Backbone an — jedes Modul wird unabhängig aktiviert, sobald seine reale Infrastruktur verifiziert ist.",
  "vp.dependency": "Reale Abhängigkeit",
  "vp.locked": "Ökosystem Phase 2 · Verifizierung ausstehend",
  "vp.earlyAccess": "Early Access",
  "vp.cta": "Early-Access-Whitelist öffnen",
  "vp.solar.desc":
    "Off-Grid-Solarmikronetze an Partnerküchen. Entkoppelt den Mahlzeitpreis von der Volatilität der Kochenergie.",
  "vp.solar.dependency":
    "Versorgt aktive MEAL24-Pilotküchen direkt mit netzunabhängiger Solarenergie.",
  "vp.planty.desc":
    "Regionale Bauernkooperativen tokenisieren Terminkontrakte für Reis, Öl und Frischware — die Upstream-Seite der MEAL4-Stabilität.",
  "vp.planty.dependency":
    "Sichert Ab-Hof-Zutatenpreise, die den täglichen MEAL2-Küchenfluss speisen.",
  "vp.aqua.desc":
    "Wasserfilter- und Getränke-Mikrostationen an den Küchen. Eliminiert den Aufschlag für abgefülltes Wasser für Personal und Gäste.",
  "vp.aqua.dependency":
    "Direkt an MEAL24-Küchen angebunden; sichert sauberes Wasser am 30-THB-Mahlzeit-Anker.",
  "vp.modal.close": "Schließen",
  "vp.modal.title": "Early Access für {module} sichern",
  "vp.modal.body":
    "Hinterlasse deinen Kontakt — wir melden uns, sobald die Whitelist dieses Moduls öffnet. Kein Spam, keine Tokenverkaufs-Versprechen.",
  "vp.modal.email": "E-Mail",
  "vp.modal.wallet": "Solana-Wallet (optional)",
  "vp.modal.note": "Notiz (optional)",
  "vp.modal.notePlaceholder":
    "Beschreibe deinen Beitrag — Betreiber, Partner, Unterstützer…",
  "vp.modal.submit": "Early Access anfragen",
  "vp.modal.submitting": "Wird übermittelt…",
  "vp.modal.privacy":
    "Speicherung in unserer sicheren Kontaktdatenbank. Nutzung ausschließlich für VillagePando-Launch-Updates.",
  "vp.modal.success.title": "Du stehst auf der Liste.",
  "vp.modal.success.body":
    "Wir melden uns, sobald dieses Modul verifiziert ist und seine Whitelist öffnet.",
  "nav.villagepando": "VillagePando",
  "nav.connectWallet": "Wallet verbinden",
  "swap.connectWallet": "Wallet zum Tauschen verbinden",
  "swap.jupiter": "Jupiter Terminal Integration · Platzhalter",
  "verify.meal4.title": "MEAL4 — Inflationsschutz-Verifizierung",
  "verify.meal4.sub": "Unveränderliche Asset-Parameter",
  "verify.meal2.title": "MEAL2 — Verifizierung des täglichen Nutzens",
  "verify.meal2.sub": "Flexible Nutzen-Parameter",
  "verify.freeze": "Freeze Authority: WIDERRUFEN",
  "verify.mint.destroyed": "Mint Authority: ZERSTÖRT",
  "verify.mint.retained": "Mint Authority: FÜR NETZWERKWACHSTUM BEIBEHALTEN",
  "verify.meal4.cta": "MEAL4 im Solana Explorer ansehen",
  "verify.meal2.cta": "MEAL2 im Solana Explorer ansehen",
  "verify.meal4.download": "MEAL4 Metadaten-JSON herunterladen",
  "verify.meal2.download": "MEAL2 Metadaten-JSON herunterladen",
  "barometer.eyebrow": "Live · On-Chain · Verifiziert",
  "barometer.title.a": "Realer",
  "barometer.title.b": "Bestands-Barometer",
  "barometer.sub":
    "Ein transparentes Fenster in die physischen Reserven, die jede Mahlzeit ermöglichen. Die Zahlen kommen direkt aus unserer Pilotküche — keine Spekulation, nur echte Bestände.",
  "barometer.rice": "Reisreserven",
  "barometer.rice.note": "12-Wochen-Puffer",
  "barometer.oil": "Pflanzenöl",
  "barometer.oil.note": "Bezug über Kooperative",
  "barometer.solar": "Solarstrom-Status",
  "barometer.live": "Live",
  "barometer.active": "Aktiv",
  "barometer.syncNote":
    "Hinweis: Alle MEAL2-Transaktionen an der Theke synchronisieren sich direkt mit unserem Echtzeit-Bestands-Barometer.",
  "tokeno.eyebrow": "// Tokenomics · Dual-Token Architektur",
  "tokeno.title": "SFN Ressourcenverteilung & Nachhaltigkeit",
  "tokeno.sub":
    "Zwei sich ergänzende Tokens, eine Stabilisierungs-Engine. MEAL4 friert den Preis von Lebensmitteln mit gedeckelten, asset-besicherten Reserven ein; MEAL2 bringt diesen Wert in jeden Teller, jede Treuebelohnung und jede gesponserte Mahlzeit im Netzwerk.",
  "tokeno.toggleAria": "Token-Verteilung",
  "tokeno.meal4.tagline": "Gedeckeltes Angebot · Asset-besicherter Wertspeicher",
  "tokeno.meal4.supply": "1.000.000 MEAL4 · Harter Cap",
  "tokeno.meal4.distTitle": "MEAL4 Verteilung",
  "tokeno.meal2.tagline": "Velocity-Schicht · Loyalität · Sponsoring",
  "tokeno.meal2.supply": "Netzwerk-Utility · Elastisches Angebot",
  "tokeno.meal2.distTitle": "MEAL2 Verteilung",
  "tokeno.centerAlloc": "SFN · ZUTEILUNG",
  "tokeno.interactEyebrow": "// So greifen die beiden Flüsse ineinander",
  "tokeno.interact.meal4": "MEAL4-Reserven",
  "tokeno.interact.meal2": "MEAL2 zirkuliert",
  "tokeno.interactBody":
    "decken das Netzwerk mit gedeckelter, geprüfter Sicherheit — sie fixieren die Zutatenkosten und stabilisieren den 30-THB-Mahlzeitenanker.",
  "tokeno.interactBody2":
    "diesen fixierten Wert in tägliche Zahlungen, Treueprogramme und gesponserte Mahlzeiten. Jede MEAL2-Transaktion an der Theke greift auf einen Preis zu, der bereits durch MEAL4 eingefroren wurde — so liest ein Investor unser Nachhaltigkeitsmodell auf einen Blick.",
  "tokeno.sr.chartSummary":
    "Ringdiagramm mit der Verteilung auf vier Segmente. Mit den Pfeiltasten links und rechts zwischen den Segmenten wechseln.",
  "tokeno.sr.chartHint": "Jedes Segment ist anklickbar, um die Detailansicht zu öffnen.",
  "tokeno.sr.legendAria":
    "Verteilungs-Segmente — mit den Pfeiltasten navigieren, Enter oder Leertaste öffnet die Details.",
  "tokeno.sr.segment": "{label}: {value} Prozent der Zuteilung.",
  "tokeno.sr.segmentHint": "Klicken oder Enter drücken, um die Detailansicht zu öffnen.",
  "tokeno.sr.activated": "Ausgewählt {label}, {value} Prozent der Zuteilung.",
  "tokeno.loading": "Verteilung wird geladen…",
  "tokeno.modal.toneSuffix": "-Metrik",
  "tokeno.modal.detailView": "Detailansicht",
  "tokeno.modal.verified": "verifiziert",
  "tokeno.modal.closeAria": "{label}-Details schließen",
  "tokeno.modal.valueAria": "Wert: {value}",
  "tokeno.preview.eyebrow": "// Live-Vorschau",
  "tokeno.preview.default":
    "💡 Wählen Sie ein Segment oder ein Tokenomics-Ziel aus, um tiefergehende On-Chain-Details und Liquiditätsabsicherungen anzuzeigen.",
  "tokeno.preview.activeEyebrow": "// Ausgewählte Zuteilung",
  "tokeno.preview.cta": "Detaillierte Aufschlüsselung öffnen",
  "tokeno.preview.allocation": "Zuteilung",
  "tokeno.preview.openAria": "Detailansicht für {label} öffnen",

  "tokeno.m4-stability.label": "Stabilitätsreserven & Liquiditätsabsicherung",
  "tokeno.m4-stability.desc":
    "Protokolleigene Liquidität, die MEAL4 gegen USDC verankert und Preisschocks absorbiert, um den 30-THB-Mahlzeit-Anker dauerhaft zu sichern.",
  "tokeno.m4-stability.expl":
    "Vierzig Prozent des gedeckelten Angebots von 1.000.000 MEAL4 hinterlegen eine tiefe, protokolleigene Liquidität. Dieser Pool absorbiert Volatilität, garantiert die jederzeitige Einlösung am 30-THB-Mahlzeit-Anker und stellt sicher, dass jeder Token-Inhaber seine reale Kaufkraft behält — unabhängig von den Marktbedingungen.",
  "tokeno.m4-stability.s1l": "Liquiditätsabsicherung",
  "tokeno.m4-stability.s1v": "Protokolleigen",
  "tokeno.m4-stability.s2l": "Primäres Handelspaar",
  "tokeno.m4-stability.s2v": "MEAL4 / USDC",
  "tokeno.m4-stability.s3l": "Mahlzeit-Anker",
  "tokeno.m4-stability.s3v": "30 THB / Mahlzeit",
  "tokeno.m4-stability.s4l": "Reserveverhältnis",
  "tokeno.m4-stability.s4v": "1 : 1,4",

  "tokeno.m4-collateral.label": "Reale Asset-Besicherung (Küchen & Land)",
  "tokeno.m4-collateral.desc":
    "1:1 gedeckt durch aktive Restaurants, Immobilien und zertifizierte Küchen-Infrastruktur.",
  "tokeno.m4-collateral.expl":
    "Dreißig Prozent von MEAL4 sind durch greifbare Vermögenswerte besichert: die Ankerküche in der Thailand-Sandbox, dazugehörige Immobilien und zertifizierte Küchen-Infrastruktur im gesamten SFN-Netzwerk. Diese Reserven verleihen MEAL4 seine Inflationsschutz-Eigenschaft — ein Wert, in den man hineingehen kann.",
  "tokeno.m4-collateral.s1l": "Anker-Küchen",
  "tokeno.m4-collateral.s1v": "1 + 6 Ausbau",
  "tokeno.m4-collateral.s2l": "Asset-Audits",
  "tokeno.m4-collateral.s2v": "Quartalsweise",
  "tokeno.m4-collateral.s3l": "Versicherungsdeckung",
  "tokeno.m4-collateral.s3v": "100%",
  "tokeno.m4-collateral.s4l": "Region",
  "tokeno.m4-collateral.s4v": "Thailand Sandbox",

  "tokeno.m4-procurement.label": "Großeinkaufs-Treasury",
  "tokeno.m4-procurement.desc":
    "Fixiert Zutatenkosten unter Marktinflation durch mehrjährige Direktverträge mit Bauern.",
  "tokeno.m4-procurement.expl":
    "Zwanzig Prozent finanzieren die strategische Einkaufs-Treasury — mehrjährige Terminverträge mit Reis-Kooperativen, Ölproduzenten und Gemüse-Höfen. Durch frühzeitige Kapitalbindung friert MEAL4 die Eingangspreise an der Quelle ein und entkoppelt unsere Küchen von der Marktinflation.",
  "tokeno.m4-procurement.s1l": "Terminverträge",
  "tokeno.m4-procurement.s1v": "12 aktiv",
  "tokeno.m4-procurement.s2l": "Reis-Puffer",
  "tokeno.m4-procurement.s2v": "12 Wochen",
  "tokeno.m4-procurement.s3l": "Öl-Puffer",
  "tokeno.m4-procurement.s3v": "8 Wochen",
  "tokeno.m4-procurement.s4l": "Ø Kostenfixierung",
  "tokeno.m4-procurement.s4v": "−18% ggü. Spot",

  "tokeno.m4-safety.label": "Audits, Compliance & Notfallreserve",
  "tokeno.m4-safety.desc":
    "Smart-Contract-Audits, regulatorische Compliance und eine Krisenreserve.",
  "tokeno.m4-safety.expl":
    "Disziplinierte zehn Prozent finanzieren das operative Fundament: wiederkehrende Smart-Contract-Audits, regulatorische Compliance in mehreren Jurisdiktionen und eine versiegelte Notfallreserve, die nur im Falle eines Lieferketten-Schocks oder einer Naturkatastrophe aktiviert wird.",
  "tokeno.m4-safety.s1l": "Abgeschlossene Audits",
  "tokeno.m4-safety.s1v": "3",
  "tokeno.m4-safety.s2l": "Notfallreserve",
  "tokeno.m4-safety.s2v": "120.000 $",
  "tokeno.m4-safety.s3l": "Compliance-Regionen",
  "tokeno.m4-safety.s3v": "2",
  "tokeno.m4-safety.s4l": "Reaktions-SLA",
  "tokeno.m4-safety.s4v": "<24 h",

  "tokeno.m2-operations.label": "Tagesbetrieb & Händler-Float",
  "tokeno.m2-operations.desc":
    "Betriebskapital, das MEAL2 an jeder Theke, jedem Terminal und jeder Partnerküche liquide hält.",
  "tokeno.m2-operations.expl":
    "Fünfundvierzig Prozent von MEAL2 zirkulieren als täglicher Händler-Float — sofortige Abwicklung an der Theke, QR-Zahlungen unter einer Sekunde und reibungsloses Aufladen. Das ist die Velocity-Schicht des SFN: Sie hält jeden Teller in Echtzeit bezahlt.",
  "tokeno.m2-operations.s1l": "Ø Abwicklung",
  "tokeno.m2-operations.s1v": "0,4 s",
  "tokeno.m2-operations.s2l": "Tagesdurchsatz",
  "tokeno.m2-operations.s2v": "8.400+ Mahlzeiten",
  "tokeno.m2-operations.s3l": "Aktive Terminals",
  "tokeno.m2-operations.s3v": "42",
  "tokeno.m2-operations.s4l": "Gebühren",
  "tokeno.m2-operations.s4v": "0%",

  "tokeno.m2-loyalty.label": "Treuebelohnungen & Cashback",
  "tokeno.m2-loyalty.desc":
    "Cashback für Stammgäste und Händler-Treuepools, die die Netzwerknutzung verstärken.",
  "tokeno.m2-loyalty.expl":
    "Fünfundzwanzig Prozent treiben die Treue-Schicht an: automatisches Cashback für wiederkehrende Gäste, Händler-Rabattpools und gestufte Rabatte, die mit zunehmender Nutzung wachsen. MEAL2 verwandelt jede Transaktion in eine Beziehung.",
  "tokeno.m2-loyalty.s1l": "Ø Cashback",
  "tokeno.m2-loyalty.s1v": "12%",
  "tokeno.m2-loyalty.s2l": "Treuestufen",
  "tokeno.m2-loyalty.s2v": "4",
  "tokeno.m2-loyalty.s3l": "Wiederbesuchsrate",
  "tokeno.m2-loyalty.s3v": "63%",
  "tokeno.m2-loyalty.s4l": "Belohnungszyklus",
  "tokeno.m2-loyalty.s4v": "Wöchentlich",

  "tokeno.m2-social.label": "Sozialhilfe & gesponserte Mahlzeiten",
  "tokeno.m2-social.desc":
    "Digitale Mahlzeiten-Patenschaften, transparent an bedürftige Familien und Senioren weitergeleitet.",
  "tokeno.m2-social.expl":
    "Zwanzig Prozent von MEAL2 treiben die Sozialhilfe-Engine an. Internationale Unterstützer sponsern Mahlzeiten digital; die Tokens werden on-chain an verifizierte Empfänger weitergeleitet — Senioren, einkommensschwache Familien und Krisenreaktions-Gruppen — einlösbar in jeder zertifizierten SFN-Küche.",
  "tokeno.m2-social.s1l": "Gesponserte Mahlzeiten / Mt.",
  "tokeno.m2-social.s1v": "8.400+",
  "tokeno.m2-social.s2l": "Aktive Empfänger",
  "tokeno.m2-social.s2v": "14.200",
  "tokeno.m2-social.s3l": "Geberländer",
  "tokeno.m2-social.s3v": "9",
  "tokeno.m2-social.s4l": "On-Chain-Nachweis",
  "tokeno.m2-social.s4v": "100%",

  "tokeno.m2-growth.label": "Ökosystem-Belohnungen & Netzwerkwachstum",
  "tokeno.m2-growth.desc":
    "Onboarding-Anreize für neue Partnerküchen, Bauern und Community-Validatoren.",
  "tokeno.m2-growth.expl":
    "Zehn Prozent sind für das Ökosystem-Wachstum reserviert: Onboarding-Zuschüsse für neue Partnerküchen, Leistungsboni für liefernde Bauern und Belohnungen für Community-Validatoren. So skaliert das Sustainable Food & Eco Network über die Anker-Küche hinaus.",
  "tokeno.m2-growth.s1l": "Küchen-Partner",
  "tokeno.m2-growth.s1v": "42",
  "tokeno.m2-growth.s2l": "Onboarding-Zuschuss",
  "tokeno.m2-growth.s2v": "Bis zu 5K MEAL2",
  "tokeno.m2-growth.s3l": "Validatoren",
  "tokeno.m2-growth.s3v": "Community-betrieben",
  "tokeno.m2-growth.s4l": "Wachstumsziel '26",
  "tokeno.m2-growth.s4v": "+120 Standorte",

  "swap2.eyebrow": "// Erwerb · Zwei Zwecke",
  "swap2.title": "Wählen Sie Ihre Teilnahmeform",
  "swap2.sub":
    "MEAL4 sichert die Infrastruktur. MEAL2 versorgt das tägliche Netzwerk. Jeder Token wird bewusst unterschiedlich erworben.",
  "tokenart.meal4": "MEAL4: Governance & Infrastruktur-Wachstum — 100 Mio. Treasury",
  "tokenart.meal2": "MEAL2: 1\u00a0$ Utility & Essensgutschein — preisgeschützt",
  "tokenart.grouplabel": "Token-Highlights",
  "tokenart.highlighted": "{token}-Münze hervorgehoben",

  "meal4.badge": "Sachwert-gedeckter Schild",
  "meal4.title": "MEAL4 Token-Verkauf",
  "meal4.subtitle": "Infrastruktur-Vertrag sichern",
  "meal4.price": "Preis",
  "meal4.priceValue": "Fester Referenzwert",
  "meal4.hardCap": "Harte Obergrenze",
  "meal4.neverInflated": "· Niemals inflationiert",
  "meal4.desc":
    "Der Erwerb von MEAL4 finanziert direkt unsere physischen Lebensmittelreserven und die Solarnetz-Infrastruktur. Er verankert langfristigen Wert im Ökosystem, um Kernkosten der Küchen zu senken.",
  "meal2.badge": "Täglicher Nutzen & Hilfe",
  "meal2.title": "MEAL2 Ausgabe",
  "meal2.subtitle": "Tägliche Mahlzeit-Guthaben holen",
  "meal2.tab.cash": "An der Kasse",
  "meal2.web3desc":
    "Tauschen Sie USDC oder SOL direkt gegen MEAL2, um sofortige Smartphone-Zahlungen zu leisten oder internationale Mahlzeiten-Sponsorships zu starten.",
  "meal2.cashdesc":
    "Keine Krypto-Wallet für tägliche Gäste nötig. Kaufen Sie MEAL2-Digitalguthaben direkt am Tresen der SFN-Pilotküche mit Thai Baht (THB) oder Kreditkarte.",
  "meal2.viewGuide": "Lokalen Einlöse-Leitfaden ansehen",
  "redemption.eyebrow": "Lokale Einlösung",
  "redemption.title": "So nutzen Sie MEAL2 am Restaurant-Tresen",
  "redemption.sub":
    "Drei einfache Schritte, um hochwertige, inflationssichere Mahlzeiten mit traditioneller Währung zu genießen.",
  "canvas.simActive": "SIM · AKTIV",
  "canvas.bulkSourcing": "BULK · BESCHAFFUNG",
  "canvas.networkScaling": "NETZWERK · SKALIERUNG",
  "canvas.mealSponsor": "MEAL · SPONSOR",
  "canvas.realContract": "REAL · VERTRAG",
  "transparency.eyebrow": "// Web3 · Vertrauen · Verifizierung",
  "transparency.h.a": "On-Chain ",
  "transparency.h.b": "Transparenz",
  "transparency.h.c": " & Verifizierung",
  "transparency.sub":
    "Das Sustainable Food & Eco Network arbeitet mit absoluter Offenheit. Prüfen Sie unsere Smart Contracts, unveränderlichen Metadaten und Token-Parameter live auf der Solana-Blockchain.",
  "transparency.jsonStructure": "Solana Metadaten JSON-Struktur",
  "transparency.jsonImmutable": "// Unveränderlich. Kann nicht geändert werden.",
  "transparency.jsonCeiling": "// Fest codierte Obergrenze.",
  "verify.scanTitle": "Smart-Contract Sicherheits-Scan",
  "verify.mainnetRealtime": "Solana Mainnet · Echtzeit",
  "verify.connecting": "Verbindung zum Solana Mainnet RPC…",
  "verify.cryptoSecured": "Kryptografisch gesichert und über Solana Mainnet RPC verifiziert.",
  "verify.genesisSnapshot": "Angezeigt über verifizierten Genesis-Snapshot",
  "verify.retryScan": "Blockchain-Scan wiederholen",
  "verify.privacyLabel": "Datenschutzhinweis:",
  "verify.privacyText":
    "Zum Schutz der Community-Sicherheit arbeitet diese Plattform ausschließlich auf Vertragsebene. SFN verfolgt, fragt oder zeigt niemals einzelne Wallet-Adressen, Administrator-Schlüssel oder Guthaben von Inhabern öffentlich an.",
  "verify.item.meal4Supply.label": "MEAL4 Höchstbestand verifiziert",
  "verify.item.meal4Supply.statusPassed": "BESTANDEN - Gedeckelt bei 1.000.000",
  "verify.item.meal4Supply.statusLive": "BESTANDEN - On-Chain-Bestand: ",
  "verify.item.meal4Mint.label": "MEAL4 Mint-Autorität",
  "verify.item.meal4Mint.statusPassed": "BESTANDEN - Zerstört (1M fest gedeckelt)",
  "verify.item.meal4Mint.statusActive": "AKTIV - Mint-Autorität vorhanden",
  "verify.item.meal4Freeze.label": "MEAL4 Freeze-Autorität",
  "verify.item.meal4Freeze.statusPassed": "BESTANDEN - Entzogen (Keine Zentralkontrolle)",
  "verify.item.meal4Freeze.statusActive": "AKTIV - Freeze-Autorität vorhanden",
  "verify.item.meal2Freeze.label": "MEAL2 Freeze-Autorität",
  "verify.item.meal2Freeze.statusPassed": "BESTANDEN - Entzogen (Liquidität freigegeben)",
  "verify.item.meal2Freeze.statusActive": "AKTIV - Freeze-Autorität vorhanden",
  "verify.item.meal2Mint.label": "MEAL2 Mint-Autorität",
  "verify.item.meal2Mint.statusRevoked": "ENTZOGEN - Bestand eingefroren",
  "verify.item.meal2Mint.statusActive": "AKTIV - Verwaltet durch SFN Growth Protocol",
  "verify.item.meal2Supply.label": "MEAL2 zirkulierender Bestand",
  "verify.item.meal2Supply.statusLive": "LIVE - ",
  "verify.badge.connecting": "Verbindung",
  "verify.badge.cached": "Zwischengespeichert",
  "verify.badge.verified": "Verifiziert",
  "verify.networkBusy": "Netzwerk ausgelastet, Verbindung wird wiederholt... (Versuch ",
  "connection.eyebrow": "// Die Verbindung",
  "connection.title": "Vom digitalen Token zum echten Teller",
  "connection.sub": "Drei bewusst gestaltete Schritte verwandeln On-Chain-Wert in eine Mahlzeit zum Anfassen.",
  "connection.step1.title": "Großhandelsbeschaffung",
  "connection.step1.text": "MEAL4-Reserven finanzieren den direkten Großvolumenbezug bei lokalen Bauern — und sichern Zutatenkosten unter der Marktinflation.",
  "connection.step2.title": "Solar-Infrastruktur",
  "connection.step2.text": "Off-Grid-Solaranlagen versorgen Partnerküchen rund um die Uhr, eliminieren Energievolatilität aus den Kosten jedes Tellers.",
  "connection.step3.title": "Einlösbare Mahlzeiten",
  "connection.step3.text": "Gäste scannen, zahlen mit MEAL2 und erhalten einen heißen, nahrhaften Teller für unter 1 US-Dollar — ein digitaler Vertrag, der an einem echten Tisch erfüllt wird.",
  "footer.marquee": "MEAL ÖKOSYSTEM · MEAL ÖKOSYSTEM · MEAL ÖKOSYSTEM",
  "jupiter.eyebrow": "// Web3 · Liquidität · Zugang",
  "jupiter.h.a": "MEAL erwerben über ",
  "jupiter.h.b": "Jupiter",
  "jupiter.desc":
    "Tauschen Sie USDC, SOL oder jeden SPL-Token direkt in unserem eingebetteten Jupiter Terminal gegen MEAL2 und MEAL4 — dem liquidesten Router auf Solana. Betreiber von Partnerküchen erhalten ihr eigenes Dashboard.",
  "jupiter.partnerLogin": "Partner-Portal Login",
  "jupiter.partnerNote": "Nur für verifizierte Küchen-Betreiber & Lieferpartner.",
  "jupiter.youReceive": "Sie erhalten",
  "vp.meta.title": "VillagePando — Ökosystem-Governance-Dashboard",
  "vp.meta.description": "Zentraler Governance-Hub für das VillagePando Real-World-Asset-Netzwerk: MEAL24, SolarPando, PlantyPando und AquaPando — vereintes TAVL, tokenübergreifende Wertströme und Portalzugang.",
  "vp.meta.ogTitle": "VillagePando — Ökosystem-Governance-Dashboard",
  "vp.meta.ogDescription": "TAVL, physische Anker-Karte und tokenübergreifende Wertströme im VillagePando Real-World-Asset-Ökosystem.",
  "vp.header.subtitle": "Governance-Dashboard",
  "vp.nav.monitor": "Monitor",
  "vp.nav.map": "Karte",
  "vp.nav.flow": "Wertströme",
  "vp.nav.portals": "Portale",
  "vp.header.mealSiteLink": "MEAL24-Seite",
  "vp.footer.tagline": "VillagePando · Makro-Governance-Hub",
  "vp.footer.networkPrefix": "Solana Mainnet ·",
  "vp.modules.meal24.tagline": "Live · Inflationsgeschützter Mahlzeiten-Anker",
  "vp.modules.solar.tagline": "Energieschicht · Off-Grid-Mikronetze",
  "vp.modules.planty.tagline": "Agrarschicht · Tokenisierte Terminverträge",
  "vp.modules.aqua.tagline": "Wasserschicht · Filtrierwasser-Hubs",
  "vp.hero.eyebrow": "// VillagePando · Master-Netzwerk",
  "vp.hero.titleLine1": "Ein Ökosystem.",
  "vp.hero.titleLine2": "Vier reale Schichten.",
  "vp.hero.body": "VillagePando ist die Governance-Dachschicht, die MEAL24 (Ernährung), SolarPando (Energie), PlantyPando (Landwirtschaft) und AquaPando (Wasser) unter einem einzigen On-Chain-Rückgrat vereint. Jedes Modul aktiviert sich unabhängig — berichtet aber hierher.",
  "vp.macro.eyebrow": "// Makro-Monitor",
  "vp.macro.title": "Gesamtzustand des Ökosystems",
  "vp.macro.sub": "Konsolidierung über MEAL24 (live) und die noch in Verifizierung befindlichen Submodule. Werte spiegeln den On-Chain-Zustand und den geprüften physischen Bestand wider.",
  "vp.macro.stat.tavl.label": "Gesamt-Value-Locked (TAVL)",
  "vp.macro.stat.tavl.delta": "+4,2 % / 30 T.",
  "vp.macro.stat.anchors.label": "Aktive physische Anker",
  "vp.macro.stat.anchors.sub": "Thailand-Sandbox-Korridor",
  "vp.macro.stat.meals.label": "Gedeckte Mahlzeiten (MEAL24)",
  "vp.macro.stat.meals.sub": "30-THB-Anker aufrechterhalten",
  "vp.macro.stat.submodules.label": "Submodule online",
  "vp.macro.stat.submodules.sub": "3 in Verifizierung",
  "vp.map.eyebrow": "// Physisches Netzwerk",
  "vp.map.title": "Thailand-Anker-Karte",
  "vp.map.sub": "Live-Betriebsknoten, die den MEAL24-Mahlzeiten-Anker versorgen — schrittweise entlang des südlichen Korridors ausgebaut.",
  "vp.map.canvasEyebrow": "// Thailand · Live-Netzwerk",
  "vp.map.canvasTitle": "Thailand-Sandbox-Korridor aktiv",
  "vp.map.ariaLabel": "Stilisierte Karte Thailands mit VillagePando-Ankerknoten",
  "vp.map.legend.active": "Aktiv",
  "vp.map.legend.pilot": "Pilot",
  "vp.map.legend.planned": "Geplant",
  "vp.map.rosterEyebrow": "// Anker-Register",
  "vp.map.rosterTitle": "Betriebs-Knoten",
  "vp.map.status.active": "aktiv",
  "vp.map.status.pilot": "pilot",
  "vp.map.status.planned": "geplant",
  "vp.flow.eyebrow": "// Tokenübergreifende Wertströme",
  "vp.flow.title": "Wertzyklus zwischen den Token",
  "vp.flow.sub": "Wie Solana-native Sub-Token physischen Wert zirkulieren lassen: Energie → Küche → Zutaten → Wasser → Mahlzeiten-Token.",
  "vp.flowGraph.eyebrow": "// Vereinte Solana-Schicht · Partikelfluss",
  "vp.flowGraph.ariaLabel": "Tokenübergreifender Fluss-Graph",
  "vp.flowGraph.caption": "Leuchtspuren zeigen tokengeleiteten Wert innerhalb derselben Solana-Schicht.",
  "vp.flowGraph.node.solar.sublabel": "Energie",
  "vp.flowGraph.node.meal24.sublabel": "Küchen-Anker",
  "vp.flowGraph.node.planty.sublabel": "Zutaten",
  "vp.flowGraph.node.aqua.sublabel": "Wasser",
  "vp.flowGraph.edge.solarToMeal": "kWh → Küche",
  "vp.flowGraph.edge.plantyToMeal": "Zutaten → Menü",
  "vp.flowGraph.edge.aquaToMeal": "Filterwasser → Service",
  "vp.flowGraph.edge.mealToPlanty": "MEAL24 → Farm-Erlös",
  "vp.portals.eyebrow": "// Nutzenübergreifende Portale",
  "vp.portals.title": "Zugänge zu den Submodulen",
  "vp.portals.sub": "MEAL24 ist live. Angrenzende Module öffnen ihre Whitelists nacheinander, sobald ihre physische Infrastruktur die Verifizierung besteht.",
  "vp.portalCard.badge.live": "Live",
  "vp.portalCard.badge.phase2": "Phase 2",
  "vp.portalCard.openPortal": "Portal öffnen",
  "vp.portalCard.contributePrefix": "Beitragen · minten",
  "vp.portalCard.joinWhitelist": "Whitelist beitreten",
  "vp.whitelistModal.badge": "Phase 2 · Whitelist",
  "vp.whitelistModal.titlePrefix": "Frühzugang zu",
  "vp.whitelistModal.titleSuffix": "sichern",
  "vp.whitelistModal.body": "Hinterlassen Sie Ihre Kontaktdaten — wir melden uns, sobald die Whitelist dieses Moduls öffnet.",
  "vp.whitelistModal.closeAria": "Schließen",
  "vp.whitelistModal.successTitle": "Sie stehen auf der Liste.",
  "vp.whitelistModal.successBody": "Wir melden uns, sobald dieses Modul seine Whitelist öffnet.",
  "vp.whitelistModal.fields.email": "E-Mail",
  "vp.whitelistModal.fields.emailPlaceholder": "sie@domain.de",
  "vp.whitelistModal.fields.wallet": "Solana-Wallet (optional)",
  "vp.whitelistModal.fields.walletPlaceholder": "Solana-Adresse",
  "vp.whitelistModal.submitting": "Wird gesendet …",
  "vp.whitelistModal.submit": "Frühzugang anfragen",
  "vp.whitelistModal.disclaimer": "Gespeichert in unserer sicheren Kontaktdatenbank. Verwendung ausschließlich für VillagePando-Launch-Updates.",
  "vp.nexus.eyebrow": "// Pando-Ökosystem · Interaktives Cockpit",
  "vp.nexus.title": "Zirkulärer Wertfluss durch das Netzwerk.",
  "vp.nexus.sub": "Jedes Asset versorgt die anderen. Tippen Sie auf einen Knoten, um zu sehen, wie er Kosten senkt und Erträge für den Rest des Ökosystems erzeugt.",
  "vp.nexus.wheelAriaLabel": "Pando-Ökosystem-Rad",
  "vp.nexus.svgTitle": "PANDO NEXUS",
  "vp.nexus.svgSubtitle": "COCKPIT",
  "vp.nexus.activateAria": "Aktivieren:",
  "vp.nexus.flowsIntoLabel": "Fließt in",
  "vp.nexus.sfn.tagline": "Zentralküche · Mahlzeiten-Anker",
  "vp.nexus.sfn.headline": "SFN ist der Nachfragemotor des Netzwerks.",
  "vp.nexus.sfn.body": "Jede in der Zentralküche produzierte Mahlzeit verbraucht Wasser, Zutaten und Energie zu vertraglich fixierten internen Konditionen — und macht die übrigen Pando-Assets damit zu wiederkehrenden, ertragsstarken Versorgungseinheiten statt zu spekulativer Infrastruktur.",
  "vp.nexus.sfn.b1.label": "Garantierte Abnahme",
  "vp.nexus.sfn.b1.value": "~1.200 Mahlzeiten/Tag bei Pilotkapazität",
  "vp.nexus.sfn.b2.label": "Interner Vertragspreis",
  "vp.nexus.sfn.b2.value": "−22 % gegenüber lokalem Großhandel",
  "vp.nexus.sfn.b3.label": "Versorgt",
  "vp.nexus.sfn.b3.value": "PlantyPando · AquaPando · VillagePando",
  "vp.nexus.planty.tagline": "Mehrjährige Zutatenversorgung",
  "vp.nexus.planty.headline": "PlantyPando reduziert das Risiko der Lebensmittelkette.",
  "vp.nexus.planty.body": "Langfristig gepachtetes, aufgeforstetes Land versorgt SFN mit tokenisierten Zutaten-Terminverträgen zu Festpreisen — das schützt die Zentralküche vor Spotmarkt-Schwankungen und wertet gleichzeitig das Land für die VillagePando-Bewohner auf.",
  "vp.nexus.planty.b1.label": "Zutaten-Absicherung",
  "vp.nexus.planty.b1.value": "Fester Terminpreis über 25 Jahre",
  "vp.nexus.planty.b2.label": "Land-Wertsteigerung",
  "vp.nexus.planty.b2.value": "Wächst unter VillagePando kumulativ",
  "vp.nexus.planty.b3.label": "Beliefert",
  "vp.nexus.planty.b3.value": "SFN-Küchen · Village-Bewohner",
  "vp.nexus.aqua.tagline": "Filterwasser-Hubs",
  "vp.nexus.aqua.headline": "AquaPando sichert die Produktionskontinuität.",
  "vp.nexus.aqua.body": "UV-gefilterte Reservoirs eliminieren das Trockenzeit-Risiko für die Zentralküche, bewässern PlantyPando-Parzellen und liefern Premium-AquaP-Wasser an die Village-Bewohner — ein Asset, dreifach monetarisiert.",
  "vp.nexus.aqua.b1.label": "Reservoir-Kapazität",
  "vp.nexus.aqua.b1.value": "20.000 L pro Hub",
  "vp.nexus.aqua.b2.label": "Erlösströme",
  "vp.nexus.aqua.b2.value": "3 (Küche · Bewässerung · Einzelhandel)",
  "vp.nexus.aqua.b3.label": "Beliefert",
  "vp.nexus.aqua.b3.value": "SFN · Village · Planty",
  "vp.nexus.solar.tagline": "Nullkosten-Energieschicht",
  "vp.nexus.solar.headline": "SolarPando bricht die Betriebskostenkurve.",
  "vp.nexus.solar.body": "Off-Grid-Mikronetze versorgen die Zentralküche, betreiben die AquaPando-Reservoirs und beleuchten jeden VillagePando-Block zu Null-Grenzenergiekosten — der größte OPEX-Posten des Netzwerks wird zum gemeinsamen, tokenisierten Asset.",
  "vp.nexus.solar.b1.label": "Spitzenerzeugung",
  "vp.nexus.solar.b1.value": "12 kWp pro Anker-Standort",
  "vp.nexus.solar.b2.label": "OPEX-Kompensation",
  "vp.nexus.solar.b2.value": "≈100 % der Küchenenergie",
  "vp.nexus.solar.b3.label": "Versorgt",
  "vp.nexus.solar.b3.value": "SFN · Village · Aqua-Pumpen",
  "vp.nexus.village.tagline": "Nachfrage- + Governance-Schicht",
  "vp.nexus.village.headline": "VillagePando schließt den Kreislauf.",
  "vp.nexus.village.body": "Wohnblöcke sind der Endverbraucher aller anderen Assets — Mahlzeiten von SFN, Energie von Solar, Wasser von Aqua, Land von Planty — und leiten wiederkehrende Haushaltsausgaben zurück in dieselben Token, die Bewohner ohnehin als Governance halten.",
  "vp.nexus.village.b1.label": "Haushaltsnachfrage",
  "vp.nexus.village.b1.value": "Wiederkehrend, nicht-spekulativ",
  "vp.nexus.village.b2.label": "Governance",
  "vp.nexus.village.b2.value": "1 Block = 1 Stimmengewicht",
  "vp.nexus.village.b3.label": "Verbraucht",
  "vp.nexus.village.b3.value": "Alle vier vorgelagerten Assets",
  "vp.rwa.eyebrow": "// Live-RWA-Terminal",
  "vp.rwa.title": "Physische Assets, On-Chain-Telemetrie",
  "vp.rwa.sub": "Jede Karte unten ist eine reale Ressource auf thailändischem Boden, gestreamt in die Ökosystem-Treasury und gespiegelt durch die zirkulierende Token-Menge.",
  "vp.rwa.viewToggleAria": "Datenansichts-Modus",
  "vp.rwa.toggle.physical": "Physisch",
  "vp.rwa.toggle.financial": "Finanziell",
  "vp.rwa.strip.tavl.label": "TAVL (live)",
  "vp.rwa.strip.tavl.physicalValue": "5 verifizierte Schichten",
  "vp.rwa.strip.chain.label": "Chain",
  "vp.rwa.strip.chain.value": "Solana Mainnet",
  "vp.rwa.strip.latency.label": "Oracle-Latenz",
  "vp.rwa.strip.latency.value": "1,2 s",
  "vp.rwa.strip.uptime.label": "Anker-Verfügbarkeit",
  "vp.rwa.strip.uptime.value": "99,98 %",
  "vp.rwa.connect.connecting": "Verbinde …",
  "vp.rwa.connect.cta": "Wallet verbinden",
  "vp.rwa.livePulse": "Live · Streaming",
  "vp.rwa.metricCard.online": "Online",
  "vp.rwa.bridge.eyebrow": "// Token-Nutzenbrücke",
  "vp.rwa.bridge.title": "MEAL2, MEAL4 und Pando bewegen reale Assets auf thailändischem Boden.",
  "vp.rwa.bridge.body": "Jede geprägte Einheit ist durch verifizierten Küchendurchsatz, Kilowattstunden, ausgelieferte Liter und Landquadratmeter besichert. Einlösung erfolgt physisch — nicht synthetisch.",
  "vp.rwa.bridge.role.meal2": "Nutzenguthaben",
  "vp.rwa.bridge.role.meal4": "Mahlzeiten-Anker",
  "vp.rwa.bridge.role.pando": "Governance",
  "vp.rwa.investor.eyebrow": "// Investor-Profil · Simuliert",
  "vp.rwa.investor.walletLabel": "Wallet",
  "vp.rwa.investor.portfolioLabel": "Portfoliowert ·",
  "vp.rwa.investor.disclaimer": "Nur-Lese-Vorschau · keine echten Schlüssel berührt",
  "vp.rwa.metric.meal24.title": "MEAL24 Ökosystem-Geschwindigkeit",
  "vp.rwa.metric.meal24.subtitle": "SFN-Zentralküchen-Durchsatz · rollierend 30 T.",
  "vp.rwa.metric.meal24.unit": "kg Moo Krob produziert",
  "vp.rwa.metric.meal24.deltaPhysical": "+8,4 % W/W",
  "vp.rwa.metric.meal24.deltaFinancial": "+6,1 % W/W",
  "vp.rwa.metric.meal24.detail": "Physische Mahlzeiten, die von der Anker-Küche verarbeitet werden und den MEAL24-Burn speisen.",
  "vp.rwa.metric.solar.title": "SolarPando Netz-Output",
  "vp.rwa.metric.solar.subtitle": "Off-Grid-Mikronetz + EV-Laden · 24 h",
  "vp.rwa.metric.solar.unit": "kWh · 37 aktive EV-Sitzungen",
  "vp.rwa.metric.solar.deltaPhysical": "+3,2 % T/T",
  "vp.rwa.metric.solar.deltaFinancial": "+2,9 % T/T",
  "vp.rwa.metric.solar.detail": "Saubere Erzeugung, geliefert an Küchen, Wasseraufbereitung und EV-Ladeplätze.",
  "vp.rwa.metric.aqua.title": "AquaPando Reserven",
  "vp.rwa.metric.aqua.subtitle": "UV-gefilterte Verteilung + Reservoirstand",
  "vp.rwa.metric.aqua.unit": "verteilt · Reservoir 82 %",
  "vp.rwa.metric.aqua.deltaPhysical": "+1,7 % T/T",
  "vp.rwa.metric.aqua.deltaFinancial": "+1,4 % T/T",
  "vp.rwa.metric.aqua.detail": "Premium-AquaP-Wasser abgefüllt und geleitet an Küche und Community-Abnahme.",
  "vp.rwa.metric.planty.title": "PlantyPando Token-Deckung",
  "vp.rwa.metric.planty.subtitle": "Gesichertes Land + Aufforstungs-Sicherheit",
  "vp.rwa.metric.planty.unit": "Langpacht · 1.624 Bäume geo-getaggt",
  "vp.rwa.metric.planty.deltaPhysical": "+4,8 % M/M",
  "vp.rwa.metric.planty.deltaFinancial": "+3,6 % M/M",
  "vp.rwa.metric.planty.detail": "Physisches Land + Biomasse als dauerhafte Deckung des PLANTY-Umlaufs.",
  "vp.rwa.metric.village.title": "VillagePando Belegung",
  "vp.rwa.metric.village.subtitle": "Smart-Wohnen, versorgt durch den Kreislauf",
  "vp.rwa.metric.village.unit": "Einheiten live · Food+Wasser+Solar",
  "vp.rwa.metric.village.deltaPhysical": "+2 Einheiten W/W",
  "vp.rwa.metric.village.deltaFinancial": "+5,0 % W/W",
  "vp.rwa.metric.village.detail": "Wohneinheiten, vollständig durch ökosystemeigene Ressourcen gedeckt.",
  "vp.rwa.wallet.token.meal2.name": "Tägliches Nutzenguthaben",
  "vp.rwa.wallet.token.meal4.name": "Mahlzeiten-Anker",
  "vp.rwa.wallet.token.pando.name": "Governance",
  "vp.rwa.wallet.token.solar.name": "SolarPando",
  "vp.rwa.wallet.token.planty.name": "PlantyPando",
  "vp.rwa.wallet.token.aqua.name": "AquaPando",
  "vp.swap.eyebrow": "// Interner DEX · Pando-Router",
  "vp.swap.title": "Ökosystem-Token-Swap",
  "vp.swap.sub": "Leiten Sie Liquidität zwischen den Schichten MEAL, Solar, Aqua, Planty und Village über den internen Pando-AMM — ein Stabilitätskanal für das real gedeckte Ökosystem.",
  "vp.swap.smartRouterLabel": "Pando Smart Router",
  "vp.swap.settingsAria": "Swap-Einstellungen",
  "vp.swap.slippageButton": "0,5 % Slippage",
  "vp.swap.panel.from": "Von",
  "vp.swap.panel.to": "An (geschätzt)",
  "vp.swap.flipAria": "Swap-Richtung tauschen",
  "vp.swap.panel.balancePrefix": "Guthaben:",
  "vp.swap.panel.amountPlaceholder": "0,0",
  "vp.swap.detail.rate.label": "Kurs",
  "vp.swap.detail.rate.same": "—",
  "vp.swap.detail.slippage.label": "Slippage-Toleranz",
  "vp.swap.detail.slippage.value": "0,50 %",
  "vp.swap.detail.slippage.hint": "Maximal akzeptable Preisbewegung vor Rücksetzung",
  "vp.swap.detail.priceImpact.label": "Preisauswirkung",
  "vp.swap.detail.networkFee.label": "Netzwerkgebühr",
  "vp.swap.detail.networkFee.suffix": "· Polygon",
  "vp.swap.detail.networkFee.hint": "Minimal — gebündelt über Polygon zkEVM Relayer",
  "vp.swap.detail.synergyBonus.label": "Ökosystem-Synergie-Bonus",
  "vp.swap.detail.minReceived.label": "Mindesterhalt",
  "vp.swap.cta.routing": "Routing über Pando …",
  "vp.swap.cta.connectWallet": "Web3-Wallet verbinden",
  "vp.swap.cta.selectDifferent": "Andere Token wählen",
  "vp.swap.cta.enterAmount": "Betrag eingeben",
  "vp.swap.cta.swap": "Assets tauschen",
  "vp.swap.picker.eyebrowInput": "// Eingabe-Token wählen",
  "vp.swap.picker.eyebrowOutput": "// Ausgabe-Token wählen",
  "vp.swap.liquidity.eyebrow": "// Pool-Tiefe",
  "vp.swap.liquidity.stableBadge": "Stabil",
  "vp.swap.liquidity.stat.pairDepth": "Paar-Tiefe",
  "vp.swap.liquidity.stat.volume24h": "24-h-Volumen",
  "vp.swap.liquidity.stat.feeTier": "Gebührenstufe",
  "vp.swap.liquidity.stat.feeTierValue": "0,15 %",
  "vp.swap.liquidity.stat.ecosystemTvl": "Ökosystem-TVL",
  "vp.swap.liquidity.utilizationLabel": "Pool-Nutzung nach Asset",
  "vp.swap.liquidity.poolsSuffix": "Pools",
  "vp.swap.liquidity.disclaimer": "Interne Liquidität wird stündlich vom Pando-Router neu ausbalanciert. Der Umlauf bleibt innerhalb des Ökosystems — keine externe DEX-Exposition, keine gebridgten Wrapper.",
  "vp.swap.connectModal.eyebrow": "// Web3-Zugang",
  "vp.swap.connectModal.title": "Wallet verbinden",
  "vp.swap.connectModal.body": "Verbinden, um Liquidität über die MEAL-, Solar-, Aqua-, Planty- und Village-Pools zu leiten.",
  "vp.swap.connectModal.wallet.phantom.tag": "Solana + Polygon",
  "vp.swap.connectModal.wallet.metamask.tag": "Polygon zkEVM",
  "vp.swap.connectModal.wallet.walletconnect.tag": "300+ Wallets",
  "vp.swap.connectModal.disclaimer": "Simulierte Verbindung · keine Schlüssel ausgetauscht",
  "vp.swap.success.eyebrow": "// Transaktion erfolgreich",
  "vp.swap.success.title": "Swap bestätigt",
  "vp.swap.success.routedPrefix": "Geroutet",
  "vp.swap.success.txHashPrefix": "TxHash",
  "vp.swap.success.doneButton": "Fertig",
  "vp.swap.token.meal2.name": "Tägliches Nutzenguthaben",
  "vp.swap.token.meal4.name": "Mahlzeiten-Anker",
  "vp.swap.token.solar.name": "SolarPando-Ertrag",
  "vp.swap.token.aqua.name": "AquaPando-Reserven",
  "vp.swap.token.planty.name": "PlantyPando-Land",
  "vp.swap.token.village.name": "VillagePando-Governance",
  "nav.language": "Sprache",
  "vp.swap.pegged.badge": "1:1 USDC-gedeckter Gutschein",
  "vp.swap.pegged.tooltip": "VillagePando ist ein 1:1 USDC-gedeckter Gutschein; Slippage- und Synergie-Berechnungen entfallen.",
  "vp.swap.tax.eyebrow": "SolarPando · Transparenz",
  "vp.swap.tax.title": "Wohin fließen die 5 %?",
  "vp.swap.tax.intro": "Jede SolarPando-Transaktion leitet pauschal 5 % in physische Hardware, Wiederaufforstung und Netzbetrieb. Die untenstehende Aufteilung ist in einer zentralen Quelle definiert und 1:1 in der SFN-Audit-Dokumentation gespiegelt — die UI kann nicht abweichen.",
  "vp.swap.tax.total": "Gesamtsteuer",
  "vp.swap.tax.perTx": "{pct} % der Transaktion",
  "vp.swap.tax.hardware.label": "Hardware-Investitionen",
  "vp.swap.tax.hardware.detail": "Solarpaneele, Batterien, Wechselrichter, EV-Ladegeräte — RWA-Akkumulation.",
  "vp.swap.tax.reforestation.label": "Wiederaufforstung",
  "vp.swap.tax.reforestation.detail": "Heimische Bäume, geo-getaggt und dauerhaft an PLANTY-Sicherheit gekoppelt.",
  "vp.swap.tax.ops.label": "Betrieb",
  "vp.swap.tax.ops.detail": "Netzwartung, Monitoring, Audit-Berichte, Personal vor Ort.",
  "vp.nexus.trio.eyebrow": "Pando-Trio · gerichteter Fluss",
  "vp.nexus.trio.caption": "Land nährt Wasser. Wasser nährt Energie. Energie kauft die Mahlzeit zurück. Mahlzeiten finanzieren das Dorf.",
  "vp.nexus.trio.step1": "Land → Wasser",
  "vp.nexus.trio.step2": "Wasser → Energie",
  "vp.nexus.trio.step3": "Energie → Mahlzeiten-Rückkauf",
  "vp.nexus.trio.step4": "Mahlzeiten → Dorf",
  "nav.tokenomics": "Tokenomics",
  "nav.roadmap": "Roadmap",
  "nav.vision": "Vision",
  "nav.whitepaper": "Whitepaper",

  // Treasury transparency & purchase receipt
  "treasury.eyebrow": "Abwicklungs-Transparenz",
  "treasury.title": "Jeder MEAL2- und MEAL4-Kauf fließt in eine einzige Treasury",
  "treasury.desc": "Käufe laufen nie über eine DEX oder eine Zwischen-Wallet. Die vollständige Zieladresse erscheint beim Hover und wird on-chain geprüft, bevor ein Button freigeschaltet wird.",
  "treasury.label": "Projekt-Treasury",
  "treasury.network": "Netzwerk",
  "treasury.copy": "Adresse kopieren",
  "treasury.copied": "Kopiert",
  "treasury.explorer": "Im Explorer ansehen",
  "treasury.status.checking": "Ziel wird geprüft",
  "treasury.status.verified": "Ziel verifiziert",
  "treasury.status.degraded": "Adresse gültig · Netzwerk ausgelastet",
  "treasury.status.invalid": "Ziel nicht verifiziert — Käufe deaktiviert",
  "receipt.eyebrow": "Transaktion abgewickelt",
  "receipt.title": "Kaufbestätigung",
  "receipt.desc": "Ihr Beitrag wurde an die SFN-Projekt-Treasury geleitet. Bewahren Sie die Signatur unten als Abwicklungsnachweis auf.",
  "receipt.amount": "Bezahlt",
  "receipt.received": "Erhalten",
  "receipt.destination": "Treasury-Ziel",
  "receipt.network": "Netzwerk",
  "receipt.hash": "Transaktionssignatur",
  "receipt.viewExplorer": "Transaktion im Explorer ansehen",
  "receipt.close": "Bestätigung schließen",
  "receipt.copyHash": "Hash kopieren",
  "receipt.hashCopied": "Hash kopiert",
  "receipt.download": "JSON laden",
  "rpc.checking": "Netzwerkziel wird geprüft…",
  "rpc.degraded": "Netzwerk ausgelastet — Adresse gültig, On-Chain-Prüfung läuft weiter",
  "rpc.invalid": "Ziel nicht verifiziert — Käufe deaktiviert",

  // Analytics consent
  "consent.title": "Analyse-Einwilligung",
  "consent.desc": "Wir nutzen anonyme, cookiefreie Produktanalyse (keine IP, kein Fingerprint), um diese Seite zu verbessern. Vor Ihrer Zustimmung wird nichts gesendet.",
  "consent.accept": "Zustimmen",
  "consent.decline": "Ablehnen",
  "meal2.tab.web3": "Digitaler Swap (Web3)",

  // Storytelling upgrades
  "arch.eyebrow": "Ökosystem-Architektur",
  "arch.title": "Wie Wert durch das Netzwerk fließt",
  "arch.sub": "Fünf verbundene Ebenen machen aus On-Chain-Token einen echten Teller Essen — und daraus wieder prüfbare Daten.",
  "arch.n1.t": "MEAL2 & MEAL4 Token",
  "arch.n1.d": "MEAL4 speichert Wert (1.000.000 Hard Cap). MEAL2 zirkuliert als tägliche Mahlzeiten-Einheit.",
  "arch.n2.t": "Lokale Küchen & Restaurants",
  "arch.n2.d": "Zertifizierte Partnerküchen akzeptieren MEAL2 und servieren eine volle Mahlzeit für fixe 30 THB.",
  "arch.n3.t": "Direktbauern & Lieferkette",
  "arch.n3.d": "Küchen kaufen direkt bei regionalen Höfen — ohne Zwischenhandel, faire Preise, kurze Wege.",
  "arch.n4.t": "Konsumenten / Web3-Wallet",
  "arch.n4.d": "Gäste halten und zahlen aus der eigenen Wallet; jede Mahlzeit wird in unter einer Sekunde auf Solana abgerechnet.",
  "arch.n5.t": "KI-Analytik & CO₂-Zertifikate",
  "arch.n5.d": "Nachfrage-, Beschaffungs- und Energiedaten speisen Prognosen und prüfbares CO₂-Reporting.",
  "trustpilot.eyebrow": "Proof of Concept · Pilotregion",
  "trustpilot.title": "In Thailand bewiesen — global im Rollout.",
  "trustpilot.desc": "Unsere Ankerküche und der Community-Hub sind bereits in Betrieb. Jeder hier beschriebene Mechanismus wird an echten Tellern, echten Bauern und echten Abrechnungen getestet, bevor er skaliert.",
  "trustpilot.b1": "Ankerküche täglich in Betrieb",
  "trustpilot.b2": "Regionales Bauern-Netzwerk",
  "trustpilot.b3": "Solarbetriebener Community-Hub",
  "trustpilot.b4": "On-Chain-Abrechnung live",
  "bento.card1.b1": "Zertifizierte Partnerküchen & lokale Bauern",
  "bento.card1.b2": "Community-finanziert, solarbetrieben",
  "bento.card1.b3": "Kosten dauerhaft niedrig und stabil",
  "bento.card2.b1": "Direkte Beschaffung — ohne Zwischenhandel",
  "bento.card2.b2": "Kurze Wege, frische Ware",
  "bento.card2.b3": "Faire, planbare Erzeugerpreise",
  "bento.card3.b1": "Immobilien & Sachwerte als Deckung",
  "bento.card3.b2": "Quartalsweiser Reserve-Nachweis",
  "bento.card3.b3": "Transparentes On-Chain-Angebot",
  "story.kitchen.alt": "Köchinnen richten frische Mahlzeiten in einer lokalen Partnerküche an",
  "story.farmer.alt": "Lokaler Bauer mit einer Kiste frisch geernteten Gemüses",
  "story.diners.alt": "Gäste teilen eine gesunde Mahlzeit und zahlen im lokalen Restaurant",
  "story.pilot.alt": "Solarbetriebener Community-Hub in der thailändischen Pilotregion",

  "loop.eyebrow": "Zirkulärer Wirkungs-Kreislauf",
  "loop.title": "Die geschlossene Nahrungs- & Infrastruktur-Ökonomie",
  "loop.sub": "Acht Schritte, ein Kreis. Der Wert, der am Tisch entsteht, fließt zurück in die Felder, das Dorf und das Energienetz, die diese Mahlzeit möglich gemacht haben.",
  "loop.step": "Schritt",
  "loop.footnote": "Jeder Schritt wird on-chain abgewickelt — lückenlos prüfbar.",
  "loop.s1.t": "Bauern / Erzeugung",
  "loop.s1.d": "Lokale Höfe liefern direkt ins Netzwerk — zu fairen, vorab vereinbarten Ab-Hof-Preisen. Keine Zwischenhändler, kurze Wege, frische Ware.",
  "loop.s2.t": "Lokales Restaurant / Küche",
  "loop.s2.d": "Zertifizierte Partnerküchen verarbeiten diese Ware nach gemeinsamen Qualitäts- und Kostenstandards zu vollwertigen Mahlzeiten.",
  "loop.s3.t": "MealToken / 30-THB-Preisfixierung",
  "loop.s3.d": "Eine Mahlzeit wird gegen einen Token eingelöst, nicht gegen einen Menüpreis. Der 30-THB-Anspruch ist on-chain fixiert und inflationssicher.",
  "loop.s4.t": "Kunde / Wallet",
  "loop.s4.d": "Gäste halten ihre Mahlzeit-Ansprüche in der eigenen Solana-Wallet und zahlen in unter einer Sekunde — ganz ohne Bankkonto.",
  "loop.s5.t": "Impact-Fonds & Rewards",
  "loop.s5.d": "Ein fester Anteil jeder Abwicklung fließt in die transparente Impact-Treasury und als Rewards an die Unterstützer zurück.",
  "loop.s6.t": "Dorf-Infrastruktur",
  "loop.s6.d": "Die Treasury finanziert physische Mikro-Infrastruktur: Küchen, Kühllager, Food-Hubs und Gemeinschaftseinrichtungen.",
  "loop.s7.t": "Solar- & Wasserenergie",
  "loop.s7.d": "Solarstrom und saubere Wassersysteme senken die Betriebskosten jeder Küche und jedes Hektars im Netzwerk.",
  "loop.s8.t": "Nachhaltiger Ertrag / Bauern",
  "loop.s8.d": "Günstigere Energie und Wasser steigern Erträge und Einkommen — und speisen den nächsten Zyklus zu noch niedrigeren Kosten.",

  "synergy.eyebrow": "Marken-Synergie",
  "synergy.body": "MealToken24 ist die Utility- und Zahlungs-Engine hinter VillagePando — unserer physischen und digitalen Impact-Tech-Infrastruktur für nachhaltige Ernährung, Energie und Wasser.",
  "synergy.b1": "MealToken24 · Zahlung & Preisfixierung",
  "synergy.b2": "VillagePando · physische Impact-Infrastruktur",
  "synergy.b3": "Eine Treasury, ein On-Chain-Ledger",

  "phase1.eyebrow": "Wo wir starten · Phase 1",
  "phase1.title": "Phase-1-Launch: Pilot-Küchennetzwerk & Smart Food Hub in der Thailand-Sandbox.",
  "phase1.body": "Bevor das Netzwerk skaliert, wird alles in einer Region bewiesen: eine laufende Ankerküche, ein regionaler Bauernkreis und ein solarbetriebener Gemeinschafts-Hub. An diesen Zahlen messen wir uns.",
  "phase1.imgAlt": "Solarbetriebenes Dorfhaus in der thailändischen Pilotregion bei Sonnenuntergang",
  "phase1.kpiNote": "Live-Pilotzahlen & Phase-1-Ziele — Aktualisierung mit jedem Quartalsbericht.",
  "phase1.k1.label": "Ausgegebene Mahlzeiten",
  "phase1.k1.note": "Seit Pilotstart",
  "phase1.k2.label": "Partnerküchen",
  "phase1.k2.note": "Phase-1-Ziel",
  "phase1.k3.label": "Solarertrag",
  "phase1.k3.note": "Auf Jahr gerechnet",
  "phase1.k4.label": "Aktive Dörfer",
  "phase1.k4.note": "Thailand-Sandbox",

  "why.eyebrow": "Warum On-Chain?",
  "why.title": "Warum braucht Ernährungssicherheit überhaupt einen Token?",
  "why.body": "100 % unveränderliche Preisstabilisierung, transparente Mittelvergabe direkt an Bauern und vertrauensfreie Governance für Mikro-Infrastruktur — drei Dinge, die Tabelle und Bankkonto nicht garantieren können.",
  "why.w1.t": "Unveränderliche Preisstabilisierung",
  "why.w1.d": "Der 30-THB-Anspruch liegt in einem Smart Contract mit hart begrenztem Angebot. Kein Betreiber kann ihn still verteuern.",
  "why.w2.t": "Transparente Bauernfinanzierung",
  "why.w2.d": "Jeder Baht, der an Höfe und Küchen fließt, ist auf Solana nachvollziehbar — Förderer prüfen die Verwendung selbst.",
  "why.w3.t": "Vertrauensfreie Mikro-Governance",
  "why.w3.d": "Entscheidungen zur Dorf-Infrastruktur und Treasury-Freigaben folgen Vertragsregeln statt einer einzelnen Unterschrift.",
  "vp.solar.imgAlt": "Solarmodule auf einem Dorfhaus in der thailändischen Pilotregion",
  "vp.planty.imgAlt": "Lokaler Bauer mit frisch geerntetem Gemüse",
  "vp.aqua.imgAlt": "Sauberes Bewässerungswasser fließt in ein grünes Gemüsefeld",
  "hero.title": "Den Preis für Essen einfrieren: Eine gesunde Mahlzeit für 1 $ – für immer.",
  "hero.sub": "Einfache Utility. Echte Infrastruktur. Angetrieben von Meal2 und Meal4.",
  "hero.badge": "Die weltweit erste Dual-Token-Lebensmittelinfrastruktur – Absicherung gegen Lebensmittelinflation, eine Mahlzeit für 1 $ nach der anderen.",
  "hero.cta": "Meal2 kaufen (1 $ Mahlzeit)",
  "hero.ghost": "Meal4 sichern (Governance)",
  "keep.title": "So halten wir Mahlzeiten bei 1 $",
  "keep.sub": "Drei reale Assets fangen den Kostendruck ab, damit der Tellerpreis stabil bleibt.",
  "keep.solar.title": "Solarenergie",
  "keep.solar.text": "Netzunabhängige Solaranlagen versorgen jede Küche und streichen Stromkosten aus dem Mahlzeitenpreis.",
  "keep.agri.title": "Landwirtschaft",
  "keep.agri.text": "Direkter Bezug vom Hof und Aufforstung fixieren Zutatenkosten ohne Zwischenhändler.",
  "keep.water.title": "Sauberes Wasser",
  "keep.water.text": "Gefilterte Wasserreservoirs sichern die tägliche Produktion auch in der Trockenzeit – ohne variable Kosten.",
  "brand.tagline": "Die 1 $-Food-Engine",
  "nav.product": "Produkt",
  "nav.pilot": "Pilotküchen",
  "swap.quote.title": "Live-Routen-Kurs",
  "swap.quote.slippage": "Max. Slippage",
  "swap.quote.expiry": "Kursgültigkeit",
  "swap.quote.minReceive": "Mindestens erhalten",
  "swap.quote.usdValue": "Geschätzter Wert",
  "swap.quote.expiresIn": "Aktualisierung in {s}s",
  "swap.quote.expired": "Kurs abgelaufen — bitte aktualisieren",
  "swap.quote.refresh": "Kurs aktualisieren",
  "swap.quote.expiredError": "Dein Kurs ist abgelaufen. Bitte aktualisiere ihn und versuche es erneut.",
  "swap.quote.slippageError": "Der SOL-Kurs hat dein Slippage-Limit überschritten. Es wurde nichts signiert.",
  "verify.badge": "Kaufnachweis",
  "verify.title": "Beleg prüfen",
  "verify.intro": "Füge deine Solana-Transaktionssignatur ein, um deinen Kauf direkt gegen das Netzwerk und das SFN-Ledger zu prüfen. Die Prüfung läuft serverseitig — ohne Wallet-Verbindung.",
  "verify.modalIntro": "Serverseitig geprüfter On-Chain-Status plus passender Ledger-Eintrag.",
  "verify.label": "Transaktionssignatur",
  "verify.placeholder": "Solana-Transaktionssignatur einfügen",
  "verify.submit": "Beleg prüfen",
  "verify.busy": "Prüfe…",
  "verify.close": "Belegprüfung schließen",
  "verify.verified": "On-Chain bestätigt",
  "verify.unreachable": "Netzwerk nicht erreichbar — bitte kurz erneut versuchen",
  "verify.notConfirmed": "Nicht bestätigt",
  "verify.invalid": "Das ist keine gültige Solana-Signatur.",
  "verify.rateLimited": "Zu viele Abfragen. Bitte warte eine Minute.",
  "verify.replay": "Diese Signatur hast du in dieser Sitzung bereits geprüft.",
  "verify.error": "Der Prüfdienst ist ausgelastet. Bitte gleich noch einmal versuchen.",
  "verify.receiptId": "Beleg-ID",
  "verify.signature": "Signatur",
  "verify.ledgerEntry": "Ledger-Eintrag",
  "verify.purchase": "Kauf",
  "verify.value": "Wert",
  "verify.wallet": "Wallet",
  "verify.checks": "Settlement-Prüfungen",
  "verify.noLedger": "Noch kein passender SFN-Ledger-Eintrag für diese Signatur. Wenn du gerade bezahlt hast, warte ein paar Sekunden und prüfe erneut.",
  "verify.explorer": "Auf Solscan ansehen",
  "admin.csv.export": "CSV herunterladen",
  "admin.csv.exportLabel": "Verkaufs-Ledger als CSV-Datei herunterladen",
  "dexRoadmap.title": "Fahrplan zu Liquidität & Indexierung",
  "dexRoadmap.phase1": "Presale & Utility-Start",
  "dexRoadmap.phase2": "Jupiter Strict List & Raydium-Liquiditätspool",
  "dexRoadmap.phase3": "CoinGecko- & CoinMarketCap-Indexierung",
  "dexRoadmap.active": "Aktiv",
  "dexRoadmap.status.active": "Aktiv",
  "dexRoadmap.status.next": "Als Nächstes",
  "dexRoadmap.status.planned": "Geplant",
  "dexRoadmap.statusLive": "Der Phasenstatus des Fahrplans ist live.",
  "dexRoadmap.statusFallback": "Live-Status nicht verfügbar – es wird der veröffentlichte Plan gezeigt.",
  "dexRoadmap.visit": "{name} in neuem Tab öffnen",
  "swap.quote.refreshing": "Kurs wird aktualisiert…",
};
